import { Form, Input, Radio } from 'antd';
import { KenyanMobileInput } from '../../../../../shared/components/KenyanMobileInput';
import { kenyanMobileRules } from '../../../../../shared/policies/kenyan-mobile-rules';

const PAYOUT_METHOD_OPTIONS = [
  { label: 'M-Pesa', value: 'mpesa' },
  { label: 'Bank', value: 'bank' },
];

/** M-Pesa xor bank details — the two field groups toggle on the radio, so only the active branch is ever required (`payoutDetailsSchema`). */
export function PayoutMethodFields() {
  return (
    <>
      <Form.Item name={['payoutDetails', 'method']} label="Payout method" rules={[{ required: true, message: 'Select a payout method' }]}>
        <Radio.Group options={PAYOUT_METHOD_OPTIONS} />
      </Form.Item>
      <Form.Item noStyle shouldUpdate={(prev, next) => prev.payoutDetails?.method !== next.payoutDetails?.method}>
        {({ getFieldValue }) =>
          getFieldValue(['payoutDetails', 'method']) === 'bank' ? (
            <>
              <Form.Item name={['payoutDetails', 'bankName']} label="Bank name" rules={[{ required: true, message: 'Enter a bank name' }]}>
                <Input />
              </Form.Item>
              <div className="grid grid-cols-2 gap-3">
                <Form.Item name={['payoutDetails', 'bankAccountName']} label="Account name" rules={[{ required: true, message: 'Enter the account name' }]}>
                  <Input />
                </Form.Item>
                <Form.Item
                  name={['payoutDetails', 'bankAccountNumber']}
                  label="Account number"
                  rules={[{ required: true, message: 'Enter the account number' }]}
                >
                  <Input />
                </Form.Item>
              </div>
            </>
          ) : (
            <Form.Item
              name={['payoutDetails', 'mpesaNumber']}
              label="M-Pesa number"
              rules={kenyanMobileRules({ required: true, requiredMessage: 'Enter an M-Pesa number' })}
            >
              <KenyanMobileInput />
            </Form.Item>
          )
        }
      </Form.Item>
    </>
  );
}
